import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import SelectMutipleForm from '../../partials/selectMultiForm';
import { LANGUAGE_SUPPORT } from '../../utils/setting';
import { styles } from './styles';



  
class SelectedLanguage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          arrSupport: [],
        };
    }
    

    supportParseToArr(json = {}) {
        let data = []; 
        LANGUAGE_SUPPORT.map((language) => {
            if(json[language] === 1) {
                data.push(language);
            }
        }) 
        return data;
    }

    supportParseToJson(arrSupport = []){  
        let data = {};  
        LANGUAGE_SUPPORT.forEach(language => { 
            data[language] = arrSupport.find(ele => ele === language) ? 1 :  0;
        })    
        return data;
    }

    componentDidMount(){  
        if(this.props.support) {
            let arrSupport = this.supportParseToArr(this.props.support);  
            this.setState({arrSupport})
        } 
    }
    
    componentWillReceiveProps(nextProps){  
        if(this.props.support !== nextProps.support && nextProps.support){ 
            let arrSupport = this.supportParseToArr(nextProps.support);            
            this.setState({arrSupport})
        }
    }
    
    
    
    
    handleChange = event => {  
        const {target} = event;

        this.setState({ arrSupport: target.value }, function() {
            const {arrSupport} = this.state;
            const jsonSupport = this.supportParseToJson(arrSupport) 
            this.props.handleSubComponentChange('support', JSON.stringify(jsonSupport)); 
        });


    }; 
    render() { 
        const { classes,t, disabled = false } = this.props; 
        const {arrSupport = []} = this.state;
        return (            
            <SelectMutipleForm
                select
                fullWidth={true}
                label={t('selectedlanguage_support')}
                disabled={disabled}
                multiple
                value={arrSupport}
                onChange={this.handleChange} 
                style={{textTransform: 'capitalize'}}
                list={LANGUAGE_SUPPORT.map(name => {
                    return {
                        label: t('select_language_'+name),
                        value: name,
                    }
                })}
            />
        );
    }
}
  
SelectedLanguage.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapState = state => ({ 
});

const mapDispatch = dispatch => ({ 
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(SelectedLanguage)));